/* eslint-disable func-call-spacing */

export default function setCaptchaDE(){

       window.mtcaptchaConfig = {
        "sitekey": "MTPublic-PVoIEE78D",
        "theme": "overcast",
        "render": "auto",
        "loadAnimation": "false",
        "autoFormValidate": true,
        "renderQueue": [],
        "customLangText": {
          "hu": {
              "inputPrompt": "Írd ide a képen látható betűket."
          }
        }
        // "lowFrictionInvisible": "force-visible",
    };
     
    (
      function(){
        var mt_service = document.createElement('script');
        mt_service.async = true;
        mt_service.src = 'https://service.mtcaptcha.com/mtcv1/client/mtcaptcha.min.js';
        (
          document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]
        ).appendChild(mt_service);
        var mt_service2 = document.createElement('script');
        mt_service2.async = true;
        mt_service2.src = 'https://service2.mtcaptcha.com/mtcv1/client/mtcaptcha2.min.js';
        ( 
          document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]
        ).appendChild(mt_service2);
    }
  )();
}